<template lang="html">
	<header class="main-header" :data-open="isMenuOpen"
		:class="displayClass(isBgLight, 'header--light')+' '+displayClass(loaded, 'loaded')" 
		v-if="isLandingMounted">
		<router-link :to="{ path: getPath('Home'), meta: {lang : currentLang} }" v-if="loaded">
			<MainLogo :isBgLight="isBgLight" :dotColor="dotColor"/>
		</router-link>
		<span :class="isMenuOpen ? 'menu-open' : ''" @click="isMenuOpen ? isMenuOpen = false : isMenuOpen = true" class="btn-mobile"><span></span></span>
		<nav :class="isMenuOpen ? 'menu-open' : ''">
			<ul>
				<li><router-link :to="{ path: getPath('ProjectsPage'), meta: {lang : currentLang} }">{{ $t("projects") }}</router-link></li>
				<li><router-link :to="{ path: getPath('Clients'), meta: {lang : currentLang} }">{{ $t("clients") }}</router-link></li>
				<li><router-link :to="{ path: getPath('About'), meta: {lang : currentLang} }">{{ $t("about") }}</router-link></li>
				<li><a href="#main-footer" v-smooth-scroll="{offset: 200}">Contact</a></li>
			</ul>
			<LangSwitcher v-if="activeLangSwitcher && currentLang" :site="site" @setLang="emitLang" :currentLang="currentLang"/>
		</nav>
	</header>
</template>

<script>
	import loaderHandler  from '@/mixins/loaderHandler.js'
	const MainLogo = () => import( /* webpackChunkName: "MainLogo" */ '@/snippets/MainLogo.vue')
	const LangSwitcher = () => import( /* webpackChunkName: "LangSwitcher" */ '@/snippets/LangSwitcher.vue')
	export default {
		mixins: [loaderHandler],
		name: 'headerSite',
		props: ['site','isBgLight', 'isLandingMounted', 'dotColor', 'currentLang'],
		components:{
			MainLogo,
			LangSwitcher
		},
		data(){
			return {
				activeLangSwitcher: true,
				isMenuOpen: false,
			}
		},
		watch:{
			$route($route){
				if(!$route){
					return
				}
				this.isMenuOpen = false;
			}
		},
		methods:{
			getPath(routeName){
				let matchingRt = this.$router.options.routes.find(rt => rt.name === routeName);
				if(!matchingRt){
					return
				}
				return matchingRt.meta[this.currentLang+'Path']
			},
			displayClass($var, $class){
				return $var ? $class : '';
			},
			emitLang(payload){
				this.$emit('setLang', payload)
			}
		},
		mounted(){
			this.displayComponent(0);
		},
	}
</script>

<style lang="scss">
 .main-header{
	opacity:0;
	@include transition(opacity .5s ease 1.5s);
	background-color:transparent;
	z-index:9999;
	&.loaded{
		opacity:1;
	}
	> a{
		z-index: 9999;
	}
	&.absolute{
		@media screen and (max-width:768px){
			padding: 2rem 2rem .5rem;
		}
		top: 0;
		position: absolute;
		left: 0;
		width: 100%;
	}
	&.header--light{
		nav a{
			color:rgba(255,255,255, .5);
			&.router-link-active,
			&.router-link-exact-active{
				color: var(--lightBgcolor);
			}
			&:hover{
				color:#ccc;
			}
		}

	}
	img{
		max-width:100px;
		width: 85px;
	}
	nav{
		padding:.19rem 0;
		color:red;
		ul{
			display:inline-block;
			li{
				margin-right: 1rem;
				display:inline-block;
				@media screen and (min-width:1024px){
					margin-right:3.4rem;
				}
				&:last-child{
					margin:0;
				}
				a{
					text-transform:uppercase;
					letter-spacing: 1.1px;
					font-weight:bold;
					font-family: 'surtSemiBold_extended', helvetica, arial, sans-serif;
					font-size:0.667rem;
					color:rgba(0,0,0,.6);
					&.router-link-exact-active{
						color: #000;
					}
					&:hover{
						color:#ccc;
					}
					
				}
			}
		}
	}
}

.btn-mobile{
	width: 30px;
	height:40px;
	display:none;
	position:relative;
	display:none;
	top:-8px;
	z-index: 9999;
	> span{
		width: 100%;
		height:2px;
		background-color:#000;
		position: relative;
		top: 50%;
		left: 0;
		display: block;
		-webkit-transform: translate(0, -50%);
		transform: translate(0, -50%);
		transition: background-color .5s ease;
		&:before,
		&:after{
			content:"";
			display:block;
			position:absolute;
			width:100%;
			height:100%;
			background-color:#000;
			top: -8px;
			left:0;
			transition: transform .5s ease;
		}
		&:after{
			top:8px;
		}
	}
	&.menu-open{
		> span{
			background-color:transparent;
			&:before{
				-webkit-transform: rotate(45deg);
				transform: rotate(45deg);
				top: 0;
			}
			&:after{
				-webkit-transform: rotate(-45deg);
				transform: rotate(-45deg);
				top: 0;
			}
		}
		
	}
}

@media screen and (max-width: 768px){
	.btn-mobile{
		display:block;
	}

	.btn-mobile > span,
	.btn-mobile > span:before, .btn-mobile > span:after{
		background-color:#fff;
	}
	.btn-mobile.menu-open > span{
		background-color:transparent;
	}

	.main-header{
		nav{
			position: fixed;
			width: 100%;
			height: 100vh;
			background-color: #fff;
			top: 0;
			left: 0;
			padding: 3.8rem 2rem 2rem;
			z-index: 9998;
			transition: transform .5s ease;
			-webkit-transform: translate(100%, 0);
			transform: translate(100%, 0);
		}
		&.header--light{
			nav.menu-open{
				background-color: #000;
			}
		}
	}

	.project-page{
		.main-header{
			background-color: #fff;
			.btn-mobile > span,
			.btn-mobile > span:before, .btn-mobile > span:after{
				background-color:#000;
			}
			.btn-mobile.menu-open > span{
				background-color:transparent;
			}
			&.header--light{
				.btn-mobile > span,
				.btn-mobile > span:before, .btn-mobile > span:after{
					background-color:#000;
				}
				.btn-mobile.menu-open > span{
					background-color:transparent;
				}
				nav.menu-open{
					background-color: #fff;
				}
				nav a{
					color:#ccc;
					&.router-link-exact-active{
						color: #000;
					}
				}
			}
		}
		#main-logo{
			path{
				fill: #000
			}
		}
	}

	.main-header nav.menu-open{
		-webkit-transform: translate(0, 0);
		transform: translate(0, 0);
	}

	.main-header nav{
		padding-top:50%;
		ul{
			display: block;
			width: 100%;
			text-align:center;
			position: relative;
			li a {
				font-size: 2.66667rem;
				line-height: 5.333333rem;
				text-transform: capitalize;
			}
		}
	}

	.main-header nav ul:not(#switcher) li{
		display:block;
	}
}


</style>
